import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LeadScannerComponent } from './lead-scanner.component';

const routes: Routes = [
  {
    path: '', component: LeadScannerComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class LeadScannerRoutingModule {
}
